import moment from 'moment';

export const MAX_ALLOWED_MEMBERS = 200;
export const LEARN_MORE_URL = 'https://help.shopify.com/en/manual/discounts/combining-discounts';
export const SHOPIFY_ADMIN_BASE_URL = 'https://admin.shopify.com/store/';

export const LINK_FILTERS = [
  { text: 'Active', value: 'Active' },
  { text: 'Deactivated', value: 'Deactivated' },
  { text: 'Expired', value: 'Expired' },
  { text: 'Paused', value: 'Paused' },
  { text: 'Others', value: 'Others' },
];

export const PROMO_FILTERS = [
  { text: 'Active', value: 'Active' },
  { text: 'Deactivated', value: 'Deactivated' },
  { text: 'Failed', value: 'Failed' },
  { text: 'Expired', value: 'Expired' },
  { text: 'Upcoming', value: 'Upcoming' },
  { text: 'Others', value: 'Others' },
];

export const OFFER_LEARN_MORE_URL = 'https://help.aspireiq.com/en/collections/2632994-sales-tracking';

export const LANDING_PAGE_HELP_URL = 'https://help.aspireiq.com/en/articles/10495715-beta-how-to-set-up-creatorstores';

export interface BoostCardData {
  id: number;
  label: string;
  boostType: string;
  amount: string;
  eligibleMembersCount: number;
  pendingBoostRewards: number[]; // id of pending boost rewards
  totalMemberCount: number;
  totalAmount?: number; // amount * pendingMembers
  discountType?: string; // percentage, fixed amount, free product
}

export function formatArchivedMessage(archivedDate: string | null, archivedUserName: string | null): string {
  if (!archivedDate || !archivedUserName) return '';

  return `This offer was archived on ${moment(archivedDate).format('MM/DD/YY')} by ${archivedUserName}. All offer insights are still available but you can no longer add new members.`;
}

export function snakeToInitCap(snake: string): string {
  return snake
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Extracts offer ID from URL path
 * @param pathname - The URL pathname to extract offer ID from
 * @returns The offer ID if found, null otherwise
 */
export function getOfferIdFromUrl(pathname: string): string | null {
  const pathMatch = pathname.match(/\/offers\/(\d+)(?:\/|$)/);
  return pathMatch ? pathMatch[1] : null;
}
